import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

const defaultProps = {};

export default function Description(props) {
    const { description } = props.author;
    const [readMore, setReadMore] = useState(false);
    const [needReadMore, setNeedReadMore] = useState(false);
    const contentRef = useRef(null);

    useEffect(() => {
        let isReadMore = contentRef?.current?.clientHeight > 300;
        setNeedReadMore(isReadMore);
        console.log(contentRef?.current?.clientHeight);
    })

    return (
        <>
        { description != "" &&
            <div className={`container bg-white desc-container ${readMore? "expand" : null}`}>
                <div ref={contentRef} dangerouslySetInnerHTML={{__html: description}}></div>
                
                { !readMore && needReadMore && 
                    <>
                        <div className='button-read-more' onClick={(e) => setReadMore(!readMore)}>Xem thêm <i class="fas fa-angle-right"></i></div>
                        <div className='bottom-div' />
                    </>
                }
            </div>
        }
        </>
    );
}

Description.defaultProps = defaultProps;